<ng-container *transloco="let t; prefix: 'sideNav.profile'">
  @let profile = this.profile();
  @if (profile) {
    <rma-avatar class="!h-16 !w-16" [avatar]="profileImage()" [name]="profile.fullName" [profileType]="profile.profileType" />
    <div class="profile-name">{{ profile.fullName }}</div>
    @if (userAgency()) {
      <div class="text-center">{{ userAgency() }}</div>
    }
    @if (currentPlanName()) {
      <p class="plan-name text-small">{{ isFreePlan() ? t('freePlanName') : currentPlanName() }}</p>
    }

    @let rating = this.rating();
    @if (rating && profile.profileType === 'Individual') {
      <div class="rating">
        <span class="span-numbers">{{ rating.ratingValue }}</span>
        <rma-icon class="star" [fill]="1" glyph="star" theme="caution" size="small" />
        <span class="ratings-text">{{ t('from') }}</span>
        <span class="span-numbers">{{ rating.reviewCount }}</span>
        <span class="ratings-text">{{ t('reviews-v2') }}</span>
      </div>
    }
    <a #rla="routerLinkActive" class="edit-profile" routerLink="/profile" data-id="nav-edit-profile-link" routerLinkActive> &nbsp; </a>
  }
</ng-container>
